import Header from "../../../Components/Header/Header"
import Sidebar from "../../../Components/Sidebar/Sidebar"
import EstimatedCardManage from "./DashboardComponent/EstimatedCard/EstimatedCardManage"
import MaintainanceManageCard from "./DashboardComponent/MaintainanceCard/MaintainanceManageCard"
import MasterCardManage from "./DashboardComponent/MasterCard/MasterCardManage"
import WorkApprovalCardManage from "./DashboardComponent/WorkApprovalCard/WorkApprovalCardManage"
import WorkProgressCardManage from "./DashboardComponent/WorkProgressCard/WorkProgressCardManage"
import { Bar, Pie } from 'react-chartjs-2';
import WorkUploadCardManage from "./DashboardComponent/WorkUpload/WorkUploadCardManage"
import { Pieoptions, WorkUploadChart } from "../../../Helper/Data"
import { useNavigate, useSearchParams } from 'react-router-dom'
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import { useAuthState } from "../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import { RoadDashMainCountDataAPI } from "../../../Redux/MainCountSlice/RoadMaintenceMainCount"
import { WardNameDataDDL } from "../../../Components/CommonDDL/WardNameDataDDL"
import { Loading } from "../../../Helper/Loading"
import GardenMaintainanceCardManage from "./GarderDashboardComponent/GardenMaintainanceCard/GardenMaintainanceCardManage"
import CommonDashboardWardNameDDL from "./CommonDashboardWardNameDDL"
import GardenMaintainanceComp from "./GarderDashboardComponent/GardenMaintainanceCard/GardenMaintainanceComp"

export const DashboardNew = () => {

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token,RoleID } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    // console.log('ProjectTypeId', ProjectTypeId)

    const [YearValue, setYearValue] = useState(null)
    const [YearLabel, setYearLabel] = useState(null)
    const [MonthValue, setMonthValue] = useState(null)
    const [MonthLabel, setMonthLabel] = useState(null)
    const [WardValue, setWardValue] = useState(null)
    const [WardLabel, setWardLabel] = useState(null)

    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    // const [Month, setMonth] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",

    // })
    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 1,
        Label: "Select",
    })

    // console.log(userDetails)

    // const RoadSidebarHide = (name, screenFlag) => {

    //     if (name === "Garden Sidebar") {
    //         navigate(`/dashboard?name=${name}`)
    //     } 
    // }
    // const navigate = useNavigate()

    const [Countdata, setCountdata] = useState('')
    const [From, set] = useState('')

    useEffect(() => {
        const data = {
            M_FinancialYearID: year.ID,
            M_WardID: Ward.ID,
            M_MonthID: Month.ID,
            M_UserID: UserID,
            Flag: 'Web',
            token: token,
            handleGetCount: handleGetCount
        }

        dispatch(RoadDashMainCountDataAPI({ data }))

    }, [year.ID, Month.ID, Ward.ID])

    const { RoadDashCountData, isLoading } = useSelector(state => state.RoadDashMainCountData)


    const handleGetCount = (data) => {
        let tempData = {}
        data.forEach((item) => {
            tempData[item.paramName] = item.totalCount
        })
        setCountdata(tempData)
    }

    // console.log(WardValue)

    return (
        <>
            {isLoading && <Loading />}
            <div>
                <Header
                    DashboardHeading="Road Maintainance"
                    setYearValue={setYearValue}
                    setMonthValue={setMonthValue}
                    FinancialYear={FinancialYear}
                    setFinancialYear={setFinancialYear}
                    Month={Month}
                    setMonth={setMonth}
                    setYearLabel={setYearLabel}
                    setMonthLabel={setMonthLabel}
                    setWardValue={setWardValue}
                    setWardLabel={setWardLabel}
                    DashboardName={DashboardName}
                    HideYearMonthDDL='Dashboard'
                    Name="Road Work"
                // ProjectTypeId={ProjectTypeId}
                />
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                        DashboardName={DashboardName} />
                    <div className="content1 content">
                        {/* <div className="pcoded-main-container main-row">
                                <div className="pcoded-content "> */}
                        {/* <!-- [ breadcrumb ] start --> */}
                        <CommonDashboardWardNameDDL
                            setWardValue={setWardValue}
                            setWardLabel={setWardLabel}
                        />

                            
                        {
                            RoleID == '1' &&
                            <GardenMaintainanceComp />
                        }
                        {/* <div className="mb-4 m-1 py-2 px-3 master_border" style={{ borderRadius: "15px"}}>
                            <GardenMaintainanceCardManage />
                        </div> */}

                        <div className=" m-1 py-2 pb-4 master_border">
                            <div className="row ">
                                <h5 className="ps-4 py-2 ml-2">Master</h5>
                            </div>
                            <MasterCardManage
                                Countdata={Countdata}
                                YearValue={YearValue}
                                YearLabel={YearLabel}
                                MonthValue={MonthValue}
                                MonthLabel={MonthLabel}
                                WardValue={WardValue}
                                WardLabel={WardLabel}
                                ProjectTypeId={ProjectTypeId}
                                DashboardName={DashboardName}
                            />
                        </div>

                        <div className="row mt-4 m-1 pt-2 pb-2 master_border ">
                            <WorkUploadCardManage
                                Countdata={Countdata}
                                YearValue={YearValue}
                                YearLabel={YearLabel}
                                // MonthValue={MonthValue}
                                // MonthLabel={MonthLabel}
                                MonthValue={Month?.ID}
                                MonthLabel={Month?.Label}
                                WardValue={WardValue}
                                WardLabel={WardLabel}
                                ProjectTypeId={ProjectTypeId}
                                DashboardName={DashboardName}
                            />
                        </div>

                        <div className="mt-4 m-1 py-2 pb-2 master_border">
                            <div className="row pb-2">
                                <div className="col-12">
                                    <h5 className="ml-4 pt-2">Work Approval</h5>
                                </div>
                            </div>
                            <WorkApprovalCardManage
                                Countdata={Countdata}
                                YearValue={YearValue}
                                YearLabel={YearLabel}
                                // MonthValue={MonthValue}
                                // MonthLabel={MonthLabel}
                                MonthValue={Month?.ID}
                                MonthLabel={Month?.Label}
                                WardValue={WardValue}
                                WardLabel={WardLabel}
                                ProjectTypeId={ProjectTypeId}
                                DashboardName={DashboardName}
                            />
                        </div>

                        <div className="row mt-4 m-1 py-2 pb-2 master_border">
                            <WorkProgressCardManage
                                Countdata={Countdata}
                                YearValue={YearValue}
                                YearLabel={YearLabel}
                                // MonthValue={MonthValue}
                                // MonthLabel={MonthLabel}
                                MonthValue={Month?.ID}
                                MonthLabel={Month?.Label}
                                WardValue={WardValue}
                                WardLabel={WardLabel}
                                ProjectTypeId={ProjectTypeId}
                                DashboardName={DashboardName}
                            />

                        </div>

                        <div className="mt-4 m-1 py-2 pb-2 master_border">
                            <div className="col-12 ">
                                <div className="row pb-3 pb-lg-2 ps-lg-3">
                                    <div className="col-12">
                                        <h5 className="ps-3 py-2 ml-1">Estimated Amount</h5>
                                    </div>
                                    <EstimatedCardManage
                                        Countdata={Countdata}
                                        YearValue={YearValue}
                                        YearLabel={YearLabel}
                                        // MonthValue={MonthValue}
                                        // MonthLabel={MonthLabel}
                                        MonthValue={Month?.ID}
                                        MonthLabel={Month?.Label}
                                        WardValue={WardValue}
                                        WardLabel={WardLabel}
                                        ProjectTypeId={ProjectTypeId}
                                        DashboardName={DashboardName}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}